import { env } from '@skin-seoul/env-utils';
import { cartClient } from '../common/cartClient';
import type { GetUserMeResponse, UpdateUserRequest, UpdateUserResponse } from './utils/types';

class UserAPIClient {
  public async getMe(): Promise<GetUserMeResponse> {
    if (env('NEXT_PUBLIC_ENV') === 'LOCAL') {
      return {
        userId: '725',
        userName: 'jason',
        email: 'jason@skin-seoul.com',
        displayName: 'jason',
        subscribed: false,
        otpVerified: false,
      };
    }
    try {
      const res = await cartClient.get('/user/me');
      return res.data;
    } catch (_e) {
      return null;
    }
  }

  public async updateUser(payload: UpdateUserRequest): Promise<UpdateUserResponse> {
    const res = await cartClient.put('/user/me', payload);
    return res.data;
  }
}

export const userAPIClient = new UserAPIClient();
